// console.log(200);
import AutoRedirect from "./js/AutoRedirect";

AutoRedirect();
